module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_b/main_pc_015e4da72e5584f0ef64f79dee10ad5a.jpg";